import { Button, useDisclosure } from "@chakra-ui/react"
import { UpdateBillingDetailsModal } from "./updateBillingDetailsModal";

export const UpdateBillingDetails = () => {
  const cardModal = useDisclosure();

  return (
    <>
     <Button size="sm" variant={"primary"} onClick={() => cardModal.onOpen()}>Change card</Button>
      <UpdateBillingDetailsModal
        isOpen={cardModal.isOpen}
        onClose={cardModal.onClose}
      />
    </>
  )
}
